import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import { LANDING } from "@/constants/testIds";

export default function Nav() {
  const navigate = useNavigate();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 22 });
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const scrollToFaq = () => {
    document.querySelector("#faq")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/75 backdrop-blur-xl border-b border-slate-200/70" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={LANDING.navLogo}
          className="flex items-center gap-2 group"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <span className="relative inline-flex items-center justify-center w-8 h-8 rounded-lg bg-[#0f172a] overflow-hidden">
            <span className="absolute inset-0 bg-[#2563EB] translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
            <span className="relative text-white font-display font-bold text-sm tracking-tighter">C</span>
          </span>
          <span className={`font-display font-semibold text-[17px] tracking-tighter transition-colors ${scrolled ? "text-slate-900" : "text-white"}`}>
            coachly<span className="text-[#10B981]">.</span>
          </span>
        </a>

        <nav className={`hidden md:flex items-center gap-8 font-body text-[14px] transition-colors ${scrolled ? "text-slate-600" : "text-white/85"}`}>
          <button
            onClick={scrollToFaq}
            className={`hover-underline transition-colors ${scrolled ? "hover:text-slate-900" : "hover:text-white"}`}
          >
            FAQ
          </button>
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={() => navigate("/apply")}
            data-testid={LANDING.navBecomeCoach}
            className={`hidden sm:inline-flex h-10 px-4 rounded-full text-sm font-medium transition-colors ${
              scrolled
                ? "btn-ghost"
                : "text-white/90 hover:text-white hover:bg-white/10"
            }`}
          >
            Become a coach
          </button>
          <button
            onClick={() => navigate("/marketplace")}
            data-testid={LANDING.navFindCoach}
            className={`h-10 px-4 md:px-5 rounded-full text-sm font-medium inline-flex items-center gap-1.5 transition-colors ${
              scrolled
                ? "btn-primary"
                : "bg-white text-slate-900 hover:bg-[#2563EB] hover:text-white"
            }`}
          >
            Find a coach
            <span aria-hidden>→</span>
          </button>
        </div>
      </div>
      <motion.div
        className="progress-bar h-[2px] bg-[#2563EB] origin-left"
        style={{ scaleX }}
      />
    </motion.header>
  );
}
